import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EquipmentComponent } from './equipment.component';
import { EquipmentRoutingModule } from './equipment-routing.module';
import {
  NbAccordionModule,
  NbActionsModule,
  NbAutocompleteModule,
  NbButtonModule,
  NbCardModule,
  NbCheckboxModule,
  NbContextMenuModule,
  NbDatepickerModule,
  NbDialogModule,
  NbIconModule,
  NbInputModule,
  NbLayoutModule,
  NbListModule,
  NbPopoverModule,
  NbRadioModule,
  NbRouteTabsetModule,
  NbSelectModule,
  NbTabsetModule,
  NbTagModule,
  NbTreeGridModule,
  NbUserModule,
} from '@nebular/theme';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../shared/shared.module';
import { EquipmentCreateComponent } from './create/createequipment.component';
import { AgGridModule } from 'ag-grid-angular';
import { EquipmentListModule } from '../../shared/component/equipment/list/equipment-list.module';
import { EquipmentInputModule } from '../../shared/component/equipment/input/equipment-input.module';
import { AttachmentsModule } from '../attachments/attachments.module';
import { CustomerInputModule } from '../../shared/component/customers/input/customer-input.module';
import { DynamicListViewModule } from '../../shared/component/dynamiclistview/dynamiclistview.module';
import { EquipmentDetailModule } from './detail/equipmentdetail.module';

@NgModule({
  declarations: [EquipmentComponent, EquipmentCreateComponent],
  imports: [
    EquipmentDetailModule,
    CommonModule,
    EquipmentRoutingModule,
    NbAccordionModule,
    NbActionsModule,
    NbButtonModule,
    NbCardModule,
    NbCheckboxModule,
    NbContextMenuModule,
    NbDatepickerModule,
    NbDialogModule,
    NbIconModule,
    NbInputModule,
    NbRouteTabsetModule,
    NbLayoutModule,
    NbListModule,
    NbRadioModule,
    NbPopoverModule,
    NbSelectModule,
    NbTagModule,
    NbTabsetModule,
    NbTreeGridModule,
    NbUserModule,
    NbAutocompleteModule,
    AgGridModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    EquipmentListModule,
    EquipmentInputModule,
    AttachmentsModule,
    CustomerInputModule,
    DynamicListViewModule,
  ],
})
export class EquipmentModule {}
